
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {urlConfig} from '@/api/urlConfig';
import {promptMessage,fetch} from '@/api/dataHandling';
import {isVehicleNumber} from '@/api/validate';
import {getken} from '@/api/getToken';
export default {
data () {
return {
carNum:'',
ToastTxt:'',
Toastshow:false,
carTxtShow1:true,
carTxtShow2:false,
showToast:false,
isSwipe: [false, false, false],
carList: [],
carTxt:[],
carTxt1:['京','津','沪','渝','冀','豫','云','辽','黑','湘','皖','鲁','新','苏','浙','赣','鄂','桂','甘','晋','蒙','陕','吉','闽','贵','粤','青','藏','川','宁','琼','使'],
carTxt2:['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','J','K','L','M','N','P','Q','R','S','T','U','V','港','澳','W','X','Y','Z','学','领',]
}
},
directives: {
TransferDom
},
components: {
Flexbox, FlexboxItem, Toast, XDialog,XHeader,XButton
},
methods: {
getData(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
fetch('post',urlConfig.sopcardGet+'?openId='+ this.openid).then(response => {
this.carList = response;
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
},
getUserId(){
let _this = this;
return new Promise(function(resolve, reject){
fetch('get',urlConfig.GetSfzh + '?openid='+_this.openid).then(response => {
resolve(response.sfzh);
}).catch(error => {

})
})
},
getPersonInfoId(sfzh){
let _this = this;
return new  Promise(function (resolve, reject) {
fetch('get',urlConfig.GetPersonInfoId + '?sfzh='+sfzh).then(response => {
_this.personInfoId = response.personInfoId;
resolve();
}).catch(error => {

})
})

},
submitMedthod(){
this.pramsData.personInfoId = this.personInfoId;
fetch('post', urlConfig.sopcardAdd, this.pramsData).then(response => {
this.ToastTxt = '添加成功！';
this.Toastshow = true;
this.getData();
}).catch(error => {

})
},
payClick(catNo){
/*window.location.href = 'https://s.bolink.club/unionapi/t?p=6274844&licence='+encodeURI(encodeURI(catNo));*/
window.location.href = 'https://www.jslife.com.cn/jscsp-front/qrcode/carNo-pay.html?key=000000008035149,p210191248';
}, //缴费
carSubmit(){
this.carNum = this.carNum.trim();
if(this.carNum !=''){
/*if(isVehicleNumber(this.carNum)){*/
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.showToast = false;
this.pramsData = {
carNo:this.carNum,
carType:'1',
};
if(this.personInfoId){
this.submitMedthod();
}else{
let _this = this;
this.getUserId().then(function(data){
return _this.getPersonInfoId(data);
}).then(function (data) {
_this.submitMedthod();
})

}
/*    }else {
this.ToastTxt = '车牌号有误,请核对！';
this.Toastshow = true;
}*/

}else{
this.ToastTxt = '请输入车牌号！';
this.Toastshow = true;
}

},
addCar(){
this.carNum = '';
this.carTxtShow1 = true;
this.carTxtShow2 = false;
this.showToast = true;
this.$refs.carinput.focus();

},
carTxtClick1(item){
this.carNum = item;
this.carTxtShow1 = false;
this.carTxtShow2 = true;
},
carTxtClick2(item){
this.carNum += item;
},
carTxtdel(){
let arry = this.carNum.split('').slice(0,this.carNum.length-1);
let arryTXT = '';
for(let i = 0;i<arry.length;i++){
arryTXT +=arry[i];
}
this.carNum = arryTXT;
if(!this.carNum){
this.carTxtShow1 = true;
this.carTxtShow2 = false;
}
}, //删除
removeTodo: function (index,item) {
fetch('post', urlConfig.sopcardDel,{carNo:item.carNo,personInfoId:item.personInfoId}).then(response => {
this.ToastTxt = '解绑成功！';
this.Toastshow = true;
this.carList.splice(index, 1);
this.isSwipe = [false, false, false];
}).catch(error => {

})

}, //解绑车牌
created:function() {
setTimeout(() => {

if (this.$refs.child) {
this.$refs.child.forEach((element, index) => {
let x, y, X, Y, swipeX, swipeY

element.addEventListener('touchstart',function(e) {
x = e.changedTouches[0].pageX
y = e.changedTouches[0].pageY
swipeX = true
swipeY = true
this.isSwipe = [false, false, false]
})
element.addEventListener('touchmove', e => {
X = event.changedTouches[0].pageX
Y = event.changedTouches[0].pageY
if (swipeX && Math.abs(X - x) - Math.abs(Y - y) > 0) {

e.stopPropagation()

if (X - x > 10) {  //滑动间距
e.preventDefault()
this.isSwipe.splice(index, 1, false)
}
if (x - X > 10) {  //滑动间距
e.preventDefault()
this.isSwipe.splice(index, 1, true)
}
swipeY = false
}
if (swipeY && Math.abs(X - x) - Math.abs(Y - y) < 0) {
swipeX = false
}
})
})
}
}, 500)
}
},
mounted(){
/* isVehicleNumber('粤BAB7216')*/
this.openid = this.$route.query.openid;
getken(this.getData);
this.basemessage = {};
}
}



// WEBPACK FOOTER //
// ./src/project/stopCarProject/stopCarIndex.vue